<template>
    <div>
        <div class="page-header clear-filter" filter-color="orange">
            <parallax
                    class="page-header-image"
                    style="background-image:url('img/bg5.jpg')"
            >
            </parallax>
            <div class="container mt-5 pt-5">
                <div class="photo-container">
                    <img :src="userModel.userData.userNewImage" alt="UserImage"/>
                </div>
                <h3 class="title">{{userModel.userData.fullName}}</h3>
                <p class="category">{{userModel.userData.mainJob}}</p>
                <h2 v-if="banners!=null" class="text-center m-3">{{banners.banner1}}</h2>
                <div class="content">
                    <div class="social-description">
                        <h2 v-if="userOptions.showComment">{{userLikes.comments}}</h2>
                        <h2 v-else>26</h2>
                        <p>کامنتها</p>
                    </div>
                    <div class="social-description">
                        <h2 v-if="userOptions.showLike">{{userLikes.likeCount}}</h2>
                        <h2 v-else>37</h2>
                        <p>پسندها</p>
                    </div>
                    <div class="social-description">
                        <h2 v-if="userOptions.showRequest">{{userLikes.requests}}</h2>
                        <h2 v-else>48</h2>
                        <p>درخواستها</p>
                    </div>
                    <div class="social-description">
                        <h2>{{userLikes.viewCount}}</h2>
                        <p>بازدیدها</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="section">
            <div class="container" style="max-width: 2000px;">
                <!--------------------------  شبکه های اجتماعی ---------------------->
                <div class="button-container">
                    <!--<a href="#button" class="btn btn-primary btn-round btn-lg">Follow</a>-->
                    <a
                            v-for="mynet in userModel.netData" :key="mynet.id"
                            :href="mynet.urlLink !== undefined && mynet.urlLink !== null ? mynet.urlLink: ''"
                            class="btn btn-default btn-round btn-lg btn-icon mx-1"
                            rel="tooltip"
                            :title="mynet.name"

                    >
                        <i class="fab " :class="mynet.icon"
                           style="font-size: larger;color: blanchedalmond;"
                           v-if="mynet.urlLink != null || mynet.urlLink !== ''"
                        ></i>
                    </a>
                    <!--<a-->
                    <!--href="#button"-->
                    <!--class="btn btn-default btn-round btn-lg btn-icon"-->
                    <!--rel="tooltip"-->
                    <!--title="Follow me on Instagram"-->
                    <!--&gt;-->
                    <!--<i class="fab fa-instagram"></i>-->
                    <!--</a>-->
                </div>
                <!----------------------- اضافه کردن به صفحه اصلی -->
                <div class="add-home-screen text-center">
                    <h4> برای افزودن میانبر به صفحه اصلی و استفاده بهتر از امکانات سایت، لطفا بر روی منوی مرورگر(... سه
                        نقطه بالای مرورگر) کلیک کرده و سپس گزینه (افزودن به صفحه اصلی) را کلیک کنید</h4>
                </div>
                <!--------------------------  مهارتها ---------------------->
                <h3 class="text-center">آشنایی با مهارتهای
                    {{userModel.userData.fullName}} </h3>
                <div class="row justify-content-center p-3">
                    <div class="col-lg-8 mb-2" v-for="skill in userModel.skills" :key="skill.id">
                        <n-progress type="primary" :value="skill.rate * 20" :label="skill.title" show-value>
                        </n-progress>
                    </div>
                </div>
                <hr/>
                <h2 v-if="banners!=null" class="text-center">{{banners.banner2}}</h2>

                <!-------------------------- زندگینامه ---------------------->
                <div class="col-md-10 ml-auto col-xl-10 mr-auto" v-if="userModel.rezomeDta[3] !==undefined">
                    <hr/>
                    <h3 class="text-center">{{userModel.rezomeDta[3].mainItemTitle}} </h3>
                    <div class="row justify-content-center">
                        <div class="col-10">
                            <el-carousel height="600px">
                                <el-carousel-item v-for="userListVms in userModel.rezomeDta[3].userListVms"
                                                  :key="userListVms.id">
                                    <img class="d-block nav2-photo-container"
                                         :src="preUrl + userListVms.subItemListImage"
                                         alt="First slide"/>
                                    <div class="" style="bottom:0px !important;"
                                         v-for="useDataVms in userListVms.useDataVms"
                                         :key="useDataVms.dataId">
                                        <div class="" style="bottom:0px !important;"
                                             v-for="userItemVms in userModel.rezomeDta[3].userItemVms"
                                             :key="userItemVms.subitemId">
                                            <div v-if="useDataVms.subItemId == userItemVms.subitemId"
                                                 class="row justify-content-center">
                                                <!--SUB ITEM TITLE------------------------->
                                                <!--<p class="btn btn-github col-3">{{userItemVms.subitemTitle}}</p>-->

                                                <!-- ITEM DATA ---------------------------->
                                                <h4 class="text_bold text-primary text-center p-3"
                                                    style="text-shadow: 3px 3px 5px #FF0000"
                                                    v-if="userItemVms.subitemTitle=='عنوان'">
                                                    {{userListVms.useDataVms[0].textData}}</h4>
                                                <div v-else style="text-align: center;">
                                                    <p class="btn btn-round btn-white btn-lg  col-8 text-center"
                                                       v-if="userItemVms.type === 1 && useDataVms.textData !==''">{{
                                                        useDataVms.textData}}</p>
                                                    <p class="btn btn-round btn-white btn-lg  col-8 text-center"
                                                       v-if="userItemVms.type === 2 && useDataVms.numberData!==0">{{
                                                        useDataVms.numberData}}</p>
                                                    <p class="btn btn-round btn-white btn-lg  col-8 text-center"
                                                       v-if="userItemVms.type === 3 && useDataVms.dateData!==''">
                                                        {{convertDate(useDataVms.dateData)}}</p>
                                                    <p class="btn btn-round btn-white btn-lg  col-8 text-center"
                                                       v-if="userItemVms.type === 4 && useDataVms.floatData!==0">{{
                                                        useDataVms.floatData}}</p>
                                                    <p class="btn btn-round btn-white btn-lg  col-8 text-center"
                                                       v-if="userItemVms.type === 5 && useDataVms.htmlData!==''"
                                                       v-html="useDataVms.htmlData"></p>
                                                    <img class="  col-8"
                                                         v-if="userItemVms.type === 6 && useDataVms.imageData!==''"
                                                         :src="preUrl  + useDataVms.imageData"
                                                         style="max-height: 15rem!important;"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <a class="btn btn-info rounded"
                                           style="position: absolute;top: 550px; left: 20px;"
                                           @click="detailCliked(userListVms.subItemListId)"> بیشتر بخوانید</a>
                                    </div>
                                </el-carousel-item>

                            </el-carousel>
                        </div>
                    </div>
                </div>


                <!-------------------------- تحصیلات---------------------->
                <div class="col-md-10 ml-auto col-xl-10 mr-auto" v-if="userModel.rezomeDta[0] !==undefined">
                    <hr/>
                    <h3 class="category">{{userModel.rezomeDta[0].mainItemTitle}}</h3>
                    <!-- Nav tabs -->
                    <card>
                        <tabs
                                slot="raw-content"
                                tab-content-classes="tab-content-padding text-center"
                                data-background-color="orange"
                        >
                            <tab-pane v-for="userListVms in userModel.rezomeDta[0].userListVms" :key="userListVms.id">
                                <template slot="label">
                                    <i class="now-ui-icons objects_umbrella-13"></i>{{userListVms.useDataVms[0].textData}}
                                </template>
                                <div v-if="userListVms.subItemListImage != ''">
                                    <img :src="preUrl  + userListVms.subItemListImage"
                                         style="max-height: 15rem!important;"/>
                                </div>
                                <div v-for="userItemVms in userModel.rezomeDta[0].userItemVms"
                                     :key="userItemVms.subitemId">
                                    <div v-for="useDataVms in userListVms.useDataVms" :key="useDataVms.dataId">
                                        <div v-if="useDataVms.subItemId == userItemVms.subitemId"
                                             class="row align-items-center clickable" @click="detailCliked(userListVms.subItemListId)">
                                            <!--SUB ITEM TITLE------------------------->
                                            <p class="btn btn-success btn-lg col-md-3 align-self-baseline">
                                                {{userItemVms.subitemTitle}}</p>

                                            <!-- ITEM DATA ---------------------------->
                                            <p class="btn btn-primary btn-lg col-md-8"
                                               v-if="userItemVms.type === 1 && useDataVms.textData !==''">{{
                                                useDataVms.textData}}</p>
                                            <p class="btn btn-primary btn-lg col-md-8"
                                               v-if="userItemVms.type === 2 && useDataVms.numberData!==0">{{
                                                useDataVms.numberData}}</p>
                                            <p class="btn btn-primary btn-lg col-md-8"
                                               v-if="userItemVms.type === 3 && useDataVms.dateData!==''">
                                                {{convertDate(useDataVms.dateData)}}</p>
                                            <p class="btn btn-primary btn-lg col-md-8"
                                               v-if="userItemVms.type === 4 && useDataVms.floatData!==0">{{
                                                useDataVms.floatData}}</p>
                                            <p class="btn btn-primary btn-lg col-md-8"
                                               v-if="userItemVms.type === 5 && useDataVms.htmlData!==''"
                                               v-html="useDataVms.htmlData"></p>
                                            <img class="  col-8"
                                                 v-if="userItemVms.type === 6 && useDataVms.imageData!==''"
                                                 :src="preUrl  + useDataVms.imageData"
                                                 style="max-height: 15rem!important;"/>

                                        </div>
                                    </div>
                                </div>
                            </tab-pane>

                        </tabs>
                    </card>
                </div>

                <!-------------------------- سوابق شغلی ---------------------->
                <div class="col-md-10 ml-auto col-xl-10 mr-auto" v-if="userModel.rezomeDta[1] !==undefined">
                    <hr/>
                    <h3 class="text-center">{{userModel.rezomeDta[1].mainItemTitle}} </h3>
                    <div class="row justify-content-center">
                        <div class="col-10">
                            <el-carousel height="500px">
                                <el-carousel-item v-for="userListVms in userModel.rezomeDta[1].userListVms"
                                                  :key="userListVms.id">
                                    <img class="d-block" :src="preUrl + userListVms.subItemListImage" alt="First slide"
                                         style="max-height: 100%;width: 100%"/>
                                    <div class="carousel-caption">
                                        <a>
                                            <h3 class="text_bold text-white mb-0"
                                                style="text-shadow: 3px 3px 5px #FF0000">
                                                {{userListVms.useDataVms[0].textData}}</h3>
                                            <div>
                                                <a class="btn btn-info rounded"

                                                   @click="detailCliked(userListVms.subItemListId)"> بیشتر بخوانید</a>
                                            </div>
                                        </a>
                                    </div>
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                    </div>
                </div>

                <!-------------------------- سوابق حزبی ---------------------->
                <div class="col-md-10 ml-auto col-xl-10 mr-auto" v-if="userModel.rezomeDta[2] !==undefined">
                    <hr/>
                    <h3 class="text-center">{{userModel.rezomeDta[2].mainItemTitle}} </h3>
                    <div   class="row justify-content-center">
                        <div class="col-10">
                            <el-carousel height="500px">
                                <el-carousel-item v-for="userListVms in userModel.rezomeDta[2].userListVms"
                                                  :key="userListVms.id">
                                    <img class="d-block nav-photo-container"
                                         :src="preUrl + userListVms.subItemListImage"
                                         alt="First slide"/>
                                    <div class="" style="bottom:0px !important;"
                                         v-for="useDataVms in userListVms.useDataVms"
                                         :key="useDataVms.dataId">
                                        <div class="" style="bottom:0px !important;"
                                             v-for="userItemVms in userModel.rezomeDta[2].userItemVms"
                                             :key="userItemVms.subitemId">
                                            <div v-if="useDataVms.subItemId == userItemVms.subitemId"
                                                 class="row justify-content-center">
                                                <!--SUB ITEM TITLE------------------------->
                                                <!--<p class="btn btn-github col-3">{{userItemVms.subitemTitle}}</p>-->

                                                <!-- ITEM DATA ---------------------------->
                                                <p class="btn btn-round col-8"
                                                   style="text-shadow: rgb(0 250 0) 3px 3px 5px;"
                                                   v-if="userItemVms.type === 1 && useDataVms.textData !==''">{{userItemVms.subitemTitle}} : {{
                                                    useDataVms.textData}}</p>
                                                <p class="btn btn-round col-8"
                                                   style="text-shadow: rgb(0 250 0) 3px 3px 5px;"
                                                   v-if="userItemVms.type === 2 && useDataVms.numberData!==0">{{userItemVms.subitemTitle}} : {{
                                                    useDataVms.numberData}}</p>
                                                <p class="btn btn-round col-8"
                                                   style="text-shadow: rgb(0 250 0) 3px 3px 5px;"
                                                   v-if="userItemVms.type === 3 && useDataVms.dateData!==''">{{userItemVms.subitemTitle}} :
                                                    {{convertDate(useDataVms.dateData)}}</p>
                                                <p class="btn btn-round col-8"
                                                   style="text-shadow: rgb(0 250 0) 3px 3px 5px;"
                                                   v-if="userItemVms.type === 4 && useDataVms.floatData!==0">{{userItemVms.subitemTitle}} : {{
                                                    useDataVms.floatData}}</p>
                                                <p class="btn btn-round col-8"
                                                   style="text-shadow: rgb(0 250 0) 3px 3px 5px;"
                                                   v-if="userItemVms.type === 5 && useDataVms.htmlData!==''"
                                                   v-html="useDataVms.htmlData"></p>
                                                <img class="  col-8"
                                                     v-if="userItemVms.type === 6 && useDataVms.imageData!==''"
                                                     :src="preUrl  + useDataVms.imageData"
                                                     style="max-height: 15rem!important;"/>

                                            </div>

                                            <!--<div>-->
                                            <!--<h4 class="text_bold text-primary text-center p-3"-->
                                            <!--style="text-shadow: 3px 3px 5px #FF0000"-->
                                            <!--v-if="userItemVms.subitemId == userListVms.">-->
                                            <!--{{userListVms.useDataVms[0].textData}}</h4>-->
                                            <!--</div>-->
                                            <!--<p class="text-black text-right p-2" style="text-shadow: 3px 3px 5px #a1a1a1;"-->
                                            <!--v-html="userListVms.useDataVms[1].htmlData"></p>-->
                                        </div>
                                    </div>
                                    <div>
                                        <a class="btn btn-info rounded"
                                           style="position: absolute;top: 450px; left: 20px;"
                                           @click="detailCliked(userListVms.subItemListId)"> بیشتر بخوانید</a>
                                    </div>
                                </el-carousel-item>

                            </el-carousel>
                        </div>
                    </div>
                </div>
                <hr/>
                <h2 v-if="banners!=null" class="text-center">{{banners.banner3}}</h2>
                <!-------------------------- برنامه ها  ---------------------->
                <div class="col-md-10 ml-auto col-xl-10 mr-auto" v-if="userModel.rezomeDta[4] !==undefined">
                    <hr/>
                    <div   class="section section-team text-center" style="top: 0;">
                        <div class="container">
                            <h3 class="text-center">{{userModel.rezomeDta[4].mainItemTitle}} </h3>
                            <el-carousel height="500px">
                                <el-carousel-item v-for="index in kindex" :key="index">
                                    <div class="team">
                                        <div class="row">
                                            <div class="col-md-4"
                                                 v-if="userModel.rezomeDta[4].userListVms[(index-1)*3]!== undefined"
                                            >
                                                <!--v-for="userListVms in userModel.rezomeDta[4].userListVms"-->
                                                <!--:key="userListVms.id">-->
                                                <div class="team-player clickable" style="max-height: 35rem;overflow: hidden;" @click="detailCliked(userModel.rezomeDta[4].userListVms[(index-1)*3].subItemListId)">
                                                    <img
                                                            :src="preUrl + userModel.rezomeDta[4].userListVms[(index-1)*3].subItemListImage"
                                                            alt="Thumbnail Image"
                                                            class="nav3-photo-container mb-3"
                                                    />
                                                    <div class="" style="bottom:0px !important;"
                                                         v-for="useDataVms in userModel.rezomeDta[4].userListVms[(index-1)*3].useDataVms"
                                                         :key="useDataVms.dataId">
                                                        <div class="" style="bottom:0px !important;"
                                                             v-for="userItemVms in userModel.rezomeDta[4].userItemVms"
                                                             :key="userItemVms.subitemId"
                                                        >
                                                            <div v-if="useDataVms.subItemId === userItemVms.subitemId"
                                                                 class="row justify-content-center">
                                                                <h4 class="title"
                                                                    v-if="userItemVms.subitemTitle === 'عنوان'">
                                                                    {{useDataVms.textData}}</h4>
                                                                <div v-else style="text-align: center;">
                                                                    <p class="category text-primary">
                                                                        {{userItemVms.subitemTitle}}</p>

                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 1 && useDataVms.textData !==''">
                                                                        {{
                                                                        useDataVms.textData}}</p>
                                                                    <p class="descriptionr"
                                                                       v-if="userItemVms.type === 2 && useDataVms.numberData!==0">
                                                                        {{
                                                                        useDataVms.numberData}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 3 && useDataVms.dateData!==''">
                                                                        {{convertDate(useDataVms.dateData)}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 4 && useDataVms.floatData!==0">
                                                                        {{
                                                                        useDataVms.floatData}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 5 && useDataVms.htmlData!==''"
                                                                       v-html="useDataVms.htmlData"></p>
                                                                    <img class="description"
                                                                         v-if="userItemVms.type === 6 && useDataVms.imageData!==''"
                                                                         :src="preUrl  + useDataVms.imageData"
                                                                         style="max-height: 15rem!important;"/>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4"
                                                 v-if="userModel.rezomeDta[4].userListVms[(index-1)*3+1]!== undefined"
                                            >
                                                <!--v-for="userListVms in userModel.rezomeDta[4].userListVms"-->
                                                <!--:key="userListVms.id">-->
                                                <div class="team-player clickable" style="max-height: 35rem;overflow: hidden;" @click="detailCliked(userModel.rezomeDta[4].userListVms[(index-1)*3+1].subItemListId)">
                                                    <img
                                                            :src="preUrl + userModel.rezomeDta[4].userListVms[(index-1)*3+1].subItemListImage"
                                                            alt="Thumbnail Image"
                                                            class="nav3-photo-container mb-3"
                                                    />
                                                    <div class="" style="bottom:0px !important;"
                                                         v-for="useDataVms in userModel.rezomeDta[4].userListVms[(index-1)*3+1].useDataVms"
                                                         :key="useDataVms.dataId">
                                                        <div class="" style="bottom:0px !important;"
                                                             v-for="userItemVms in userModel.rezomeDta[4].userItemVms"
                                                             :key="userItemVms.subitemId"
                                                        >
                                                            <div v-if="useDataVms.subItemId === userItemVms.subitemId"
                                                                 class="row justify-content-center">
                                                                <h4 class="title"
                                                                    v-if="userItemVms.subitemTitle === 'عنوان'">
                                                                    {{useDataVms.textData}}</h4>
                                                                <div v-else style="text-align: center;">
                                                                    <p class="category text-primary">
                                                                        {{userItemVms.subitemTitle}}</p>

                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 1 && useDataVms.textData !==''">
                                                                        {{
                                                                        useDataVms.textData}}</p>
                                                                    <p class="descriptionr"
                                                                       v-if="userItemVms.type === 2 && useDataVms.numberData!==0">
                                                                        {{
                                                                        useDataVms.numberData}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 3 && useDataVms.dateData!==''">
                                                                        {{convertDate(useDataVms.dateData)}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 4 && useDataVms.floatData!==0">
                                                                        {{
                                                                        useDataVms.floatData}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 5 && useDataVms.htmlData!==''"
                                                                       v-html="useDataVms.htmlData"></p>
                                                                    <img class="description"
                                                                         v-if="userItemVms.type === 6 && useDataVms.imageData!==''"
                                                                         :src="preUrl  + useDataVms.imageData"
                                                                         style="max-height: 15rem!important;"/>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4"
                                                 v-if="userModel.rezomeDta[4].userListVms[(index-1)*3+2]!== undefined"
                                            >
                                                <!--v-for="userListVms in userModel.rezomeDta[4].userListVms"-->
                                                <!--:key="userListVms.id">-->
                                                <div class="team-player clickable" style="max-height: 35rem;overflow: hidden;" @click="detailCliked(userModel.rezomeDta[4].userListVms[(index-1)*3+2].subItemListId)">
                                                    <img
                                                            :src="preUrl + userModel.rezomeDta[4].userListVms[(index-1)*3+2].subItemListImage"
                                                            alt="Thumbnail Image"
                                                            class="nav3-photo-container mb-3"
                                                    />
                                                    <div class="" style="bottom:0px !important;"
                                                         v-for="useDataVms in userModel.rezomeDta[4].userListVms[(index-1)*3+2].useDataVms"
                                                         :key="useDataVms.dataId">
                                                        <div class="" style="bottom:0px !important;"
                                                             v-for="userItemVms in userModel.rezomeDta[4].userItemVms"
                                                             :key="userItemVms.subitemId"
                                                        >
                                                            <div v-if="useDataVms.subItemId === userItemVms.subitemId"
                                                                 class="row justify-content-center">
                                                                <h4 class="title"
                                                                    v-if="userItemVms.subitemTitle === 'عنوان'">
                                                                    {{useDataVms.textData}}</h4>
                                                                <div v-else style="text-align: center;">
                                                                    <p class="category text-primary">
                                                                        {{userItemVms.subitemTitle}}</p>

                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 1 && useDataVms.textData !==''">
                                                                        {{
                                                                        useDataVms.textData}}</p>
                                                                    <p class="descriptionr"
                                                                       v-if="userItemVms.type === 2 && useDataVms.numberData!==0">
                                                                        {{
                                                                        useDataVms.numberData}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 3 && useDataVms.dateData!==''">
                                                                        {{convertDate(useDataVms.dateData)}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 4 && useDataVms.floatData!==0">
                                                                        {{
                                                                        useDataVms.floatData}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 5 && useDataVms.htmlData!==''"
                                                                       v-html="useDataVms.htmlData"></p>
                                                                    <img class="description"
                                                                         v-if="userItemVms.type === 6 && useDataVms.imageData!==''"
                                                                         :src="preUrl  + useDataVms.imageData"
                                                                         style="max-height: 15rem!important;"/>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                    </div>
                </div>

                <!-------------------------- اخبار  ---------------------->
                <div class="col-md-10 ml-auto col-xl-10 mr-auto" v-if="userModel.rezomeDta[6] !==undefined">
                    <hr/>
                    <div class=" text-center" style="top: 0;">
                        <div class="container">
                            <h3 class="text-center">{{userModel.rezomeDta[6].mainItemTitle}} </h3>
                            <div class="team" >
                                <div class="row h-100">
                                    <div class="col-lg-4" v-for="userListVms in userModel.rezomeDta[6].userListVms"
                                         :key="userListVms.id">
                                        <div class="card team-player" style="max-height: 35rem;overflow: hidden;">
                                            <img
                                                    :src="preUrl + userListVms.subItemListImage"
                                                    alt="Thumbnail Image"
                                                    class="nav3-photo-container"
                                            />
                                            <div class="card-body clickable py-0" style="bottom:0px !important;"
                                                 v-for="useDataVms in userListVms.useDataVms"
                                                 :key="useDataVms.dataId"
                                                 @click="detailCliked(userListVms.subItemListId)">
                                                <div class="" style="bottom:0px !important;"
                                                     v-for="userItemVms in userModel.rezomeDta[6].userItemVms"
                                                     :key="userItemVms.subitemId">
                                                    <div v-if="useDataVms.subItemId == userItemVms.subitemId"
                                                         class="row justify-content-center">
                                                        <h4 class="title" v-if="userItemVms.subitemTitle=='عنوان'">
                                                            {{useDataVms.textData}}</h4>
                                                        <div v-else style="text-align: center;">
                                                            <p class="category text-primary">
                                                                {{userItemVms.subitemTitle}}</p>

                                                            <p class="description"
                                                               v-if="userItemVms.type === 1 && useDataVms.textData !==''">
                                                                {{
                                                                useDataVms.textData}}</p>
                                                            <p class="descriptionr"
                                                               v-if="userItemVms.type === 2 && useDataVms.numberData!==0">
                                                                {{
                                                                useDataVms.numberData}}</p>
                                                            <p class="description"
                                                               v-if="userItemVms.type === 3 && useDataVms.dateData!==''">
                                                                {{convertDate(useDataVms.dateData)}}</p>
                                                            <p class="description"
                                                               v-if="userItemVms.type === 4 && useDataVms.floatData!==0">
                                                                {{
                                                                useDataVms.floatData}}</p>
                                                            <p class="description"
                                                               v-if="userItemVms.type === 5 && useDataVms.htmlData!==''"
                                                               v-html="useDataVms.htmlData"></p>
                                                            <img class="description"
                                                                 v-if="userItemVms.type === 6 && useDataVms.imageData!==''"
                                                                 :src="preUrl  + useDataVms.imageData"
                                                                 style="max-height: 15rem!important;"/>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--------------------------  افتخارات ---------------------->
                <div class="col-md-10 ml-auto col-xl-10 mr-auto" v-if="userModel.rezomeDta[5] !==undefined">
                    <hr/>
                    <h3 class="text-center">{{userModel.rezomeDta[5].mainItemTitle}} </h3>
                    <div class="row justify-content-center">
                        <div class="col-10">
                            <el-carousel style="height: 100% !important;">
                                <el-carousel-item v-for="userListVms in userModel.rezomeDta[5].userListVms"
                                                  :key="userListVms.id">
                                    <img class="d-block nav-photo-container"
                                         :src="preUrl + userListVms.subItemListImage"
                                         alt="First slide"/>
                                    <div class="" style="bottom:0px !important;">
                                        <h4 class="text_bold text-primary text-center p-3"
                                            style="text-shadow: 3px 3px 5px #FF0000">
                                            {{userListVms.useDataVms[0].textData}}</h4>
                                        <p class="text-black text-right p-2" style="text-shadow: 3px 3px 5px #a1a1a1;"
                                           v-html="userListVms.useDataVms[1].htmlData"></p>
                                    </div>
                                    <div>
                                        <a class="btn btn-info rounded"
                                           style="position: absolute;top: 250px; left: 20px;"
                                           @click="detailCliked(userListVms.subItemListId)"> بیشتر بخوانید</a>
                                    </div>
                                </el-carousel-item>

                            </el-carousel>
                        </div>
                    </div>
                </div>

                <!-------------------------- مقالات ---------------------->
                <div class="col-md-10 ml-auto col-xl-10 mr-auto" v-if="userModel.rezomeDta[7] !==undefined">
                    <hr/>
                    <h3 class="category">{{userModel.rezomeDta[7].mainItemTitle}}</h3>
                    <!-- Nav tabs -->
                    <card>
                        <tabs
                                slot="raw-content"
                                tab-content-classes="tab-content-padding text-center"
                                data-background-color="orange"
                        >
                            <tab-pane v-for="userListVms in userModel.rezomeDta[7].userListVms" :key="userListVms.id">
                                <template slot="label">
                                    <i class="now-ui-icons objects_umbrella-13"></i>{{userListVms.useDataVms[0].textData}}
                                </template>
                                <div v-if="userListVms.subItemListImage != ''">
                                    <img :src="preUrl  + userListVms.subItemListImage"
                                         style="max-height: 15rem!important;"/>
                                </div>
                                <div v-for="userItemVms in userModel.rezomeDta[7].userItemVms"
                                     :key="userItemVms.subitemId">
                                    <div v-for="useDataVms in userListVms.useDataVms" :key="useDataVms.dataId">
                                        <div v-if="useDataVms.subItemId == userItemVms.subitemId"
                                             class="row align-items-center">
                                            <!--SUB ITEM TITLE------------------------->
                                            <p class="btn btn-success btn-lg col-md-3 align-self-baseline">
                                                {{userItemVms.subitemTitle}}</p>

                                            <!-- ITEM DATA ---------------------------->
                                            <p class="btn btn-primary btn-lg col-md-8"
                                               v-if="userItemVms.type === 1 && useDataVms.textData !==''">{{
                                                useDataVms.textData}}</p>
                                            <p class="btn btn-primary btn-lg col-md-8"
                                               v-if="userItemVms.type === 2 && useDataVms.numberData!==0">{{
                                                useDataVms.numberData}}</p>
                                            <p class="btn btn-primary btn-lg col-md-8"
                                               v-if="userItemVms.type === 3 && useDataVms.dateData!==''">
                                                {{convertDate(useDataVms.dateData)}}</p>
                                            <p class="btn btn-primary btn-lg col-md-8"
                                               v-if="userItemVms.type === 4 && useDataVms.floatData!==0">{{
                                                useDataVms.floatData}}</p>
                                            <p class="btn btn-primary btn-lg col-md-8"
                                               v-if="userItemVms.type === 5 && useDataVms.htmlData!==''"
                                               v-html="useDataVms.htmlData"></p>
                                            <img class="  col-8"
                                                 v-if="userItemVms.type === 6 && useDataVms.imageData!==''"
                                                 :src="preUrl  + useDataVms.imageData"
                                                 style="max-height: 15rem!important;"/>

                                        </div>
                                    </div>
                                </div>
                            </tab-pane>

                        </tabs>
                    </card>
                </div>
                <hr/>
                <h2 v-if="banners!=null" class="text-center">{{banners.banner4}}</h2>

                <!-------------------------- xxxxxxx  ---------------------->
                <div class="col-md-10 ml-auto col-xl-10 mr-auto" v-if="userModel.rezomeDta[9] !==undefined">
                    <hr/>
                    <h3 class="text-center">{{userModel.rezomeDta[9].mainItemTitle}} </h3>
                    <div class="row justify-content-center">
                        <div class="col-10">
                            <el-carousel height="500px">
                                <el-carousel-item v-for="userListVms in userModel.rezomeDta[9].userListVms"
                                                  :key="userListVms.id">
                                    <img class="d-block" :src="preUrl + userListVms.subItemListImage" alt="First slide"
                                         style="max-height: 100%;width: 100%"/>
                                    <div class="carousel-caption">
                                        <a>
                                            <h3 class="text_bold text-white mb-0"
                                                style="text-shadow: 3px 3px 5px #FF0000">
                                                {{userListVms.useDataVms[0].textData}}</h3>
                                            <div>
                                                <a class="btn btn-info rounded"

                                                   @click="detailCliked(userListVms.subItemListId)"> بیشتر بخوانید</a>
                                            </div>
                                        </a>
                                    </div>
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                    </div>
                </div>
                <!-------------------------- برنامه دیدارها ---------------------->
                <div class="col-md-10 ml-auto col-xl-10 mr-auto" v-if="userModel.rezomeDta[8] !==undefined">
                    <hr/>
                    <h3 class="text-center">{{userModel.rezomeDta[8].mainItemTitle}} </h3>
                    <div class="row justify-content-center">
                        <div class="col-10">
                            <el-carousel height="500px">
                                <el-carousel-item v-for="userListVms in userModel.rezomeDta[8].userListVms"
                                                  :key="userListVms.id">
                                    <img class="d-block nav-photo-container"
                                         :src="preUrl + userListVms.subItemListImage"
                                         alt="First slide"/>
                                    <div class="" style="bottom:0px !important;"
                                         v-for="useDataVms in userListVms.useDataVms"
                                         :key="useDataVms.dataId">
                                        <div class="" style="bottom:0px !important;"
                                             v-for="userItemVms in userModel.rezomeDta[8].userItemVms"
                                             :key="userItemVms.subitemId">
                                            <div v-if="useDataVms.subItemId == userItemVms.subitemId"
                                                 class="row justify-content-center">
                                                <!--SUB ITEM TITLE------------------------->
                                                <!--<p class="btn btn-github col-3">{{userItemVms.subitemTitle}}</p>-->

                                                <!-- ITEM DATA ---------------------------->
                                                <p class="btn btn-round col-8"
                                                   style="text-shadow: rgb(0 250 0) 3px 3px 5px;"
                                                   v-if="userItemVms.type === 1 && useDataVms.textData !==''">{{userItemVms.subitemTitle}} :
                                                    {{useDataVms.textData}}</p>
                                                <p class="btn btn-round col-8"
                                                   style="text-shadow: rgb(0 250 0) 3px 3px 5px;"
                                                   v-if="userItemVms.type === 2 && useDataVms.numberData!==0">{{userItemVms.subitemTitle}} : {{
                                                    useDataVms.numberData}}</p>
                                                <p class="btn btn-round col-8"
                                                   style="text-shadow: rgb(0 250 0) 3px 3px 5px;"
                                                   v-if="userItemVms.type === 3 && useDataVms.dateData!==''">{{userItemVms.subitemTitle}} :
                                                     {{convertDate(useDataVms.dateData)}} </p>
                                                <p class="btn btn-round col-8"
                                                   style="text-shadow: rgb(0 250 0) 3px 3px 5px;"
                                                   v-if="userItemVms.type === 4 && useDataVms.floatData!==0">{{userItemVms.subitemTitle}} : {{
                                                    useDataVms.floatData}}</p>
                                                <p class="btn btn-round col-8"
                                                   style="text-shadow: rgb(0 250 0) 3px 3px 5px;"
                                                   v-if="userItemVms.type === 5 && useDataVms.htmlData!==''"
                                                   v-html="useDataVms.htmlData"></p>
                                                <img class="  col-8"
                                                     v-if="userItemVms.type === 6 && useDataVms.imageData!==''"
                                                     :src="preUrl  + useDataVms.imageData"
                                                     style="max-height: 15rem!important;"/>

                                            </div>

                                            <!--<div>-->
                                            <!--<h4 class="text_bold text-primary text-center p-3"-->
                                            <!--style="text-shadow: 3px 3px 5px #FF0000"-->
                                            <!--v-if="userItemVms.subitemId == userListVms.">-->
                                            <!--{{userListVms.useDataVms[0].textData}}</h4>-->
                                            <!--</div>-->
                                            <!--<p class="text-black text-right p-2" style="text-shadow: 3px 3px 5px #a1a1a1;"-->
                                            <!--v-html="userListVms.useDataVms[1].htmlData"></p>-->
                                        </div>
                                    </div>
                                    <div>
                                        <a class="btn btn-info rounded"
                                           style="position: absolute;top: 450px; left: 20px;"
                                           @click="detailCliked(userListVms.subItemListId)"> بیشتر بخوانید</a>
                                    </div>
                                </el-carousel-item>

                            </el-carousel>
                        </div>
                    </div>
                </div>

                <!-------------------------- زندگینامه222222 ---------------------->
                <div class="col-md-10 ml-auto col-xl-10 mr-auto" v-if="userModel.rezomeDta[10] !==undefined">
                    <hr/>
                    <div class="section section-team text-center" style="top: 0;">
                        <div class="container">
                            <h3 class="text-center">{{userModel.rezomeDta[10].mainItemTitle}} </h3>
                            <el-carousel height="500px">
                                <el-carousel-item v-for="index in kindex" :key="index">
                                    <div class="team">
                                        <div class="row">
                                            <div class="col-md-4"
                                                 v-if="userModel.rezomeDta[4].userListVms[(index-1)*3]!== undefined"
                                            >
                                                <!--v-for="userListVms in userModel.rezomeDta[4].userListVms"-->
                                                <!--:key="userListVms.id">-->
                                                <div class="team-player">
                                                    <img
                                                            :src="preUrl + userModel.rezomeDta[10].userListVms[(index-1)*3].subItemListImage"
                                                            alt="Thumbnail Image"
                                                            class="nav3-photo-container mb-3"
                                                    />
                                                    <div class="" style="bottom:0px !important;"
                                                         v-for="useDataVms in userModel.rezomeDta[10].userListVms[(index-1)*3].useDataVms"
                                                         :key="useDataVms.dataId">
                                                        <div class="" style="bottom:0px !important;"
                                                             v-for="userItemVms in userModel.rezomeDta[10].userItemVms"
                                                             :key="userItemVms.subitemId"
                                                        >
                                                            <div v-if="useDataVms.subItemId === userItemVms.subitemId"
                                                                 class="row justify-content-center">
                                                                <h4 class="title"
                                                                    v-if="userItemVms.subitemTitle === 'عنوان'">
                                                                    {{useDataVms.textData}}</h4>
                                                                <div v-else style="text-align: center;">
                                                                    <p class="category text-primary">
                                                                        {{userItemVms.subitemTitle}}</p>

                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 1 && useDataVms.textData !==''">
                                                                        {{
                                                                        useDataVms.textData}}</p>
                                                                    <p class="descriptionr"
                                                                       v-if="userItemVms.type === 2 && useDataVms.numberData!==0">
                                                                        {{
                                                                        useDataVms.numberData}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 3 && useDataVms.dateData!==''">
                                                                        {{convertDate(useDataVms.dateData)}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 4 && useDataVms.floatData!==0">
                                                                        {{
                                                                        useDataVms.floatData}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 5 && useDataVms.htmlData!==''"
                                                                       v-html="useDataVms.htmlData"></p>
                                                                    <img class="description"
                                                                         v-if="userItemVms.type === 6 && useDataVms.imageData!==''"
                                                                         :src="preUrl  + useDataVms.imageData"
                                                                         style="max-height: 15rem!important;"/>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4"
                                                 v-if="userModel.rezomeDta[10].userListVms[(index-1)*3+1]!== undefined"
                                            >
                                                <!--v-for="userListVms in userModel.rezomeDta[10].userListVms"-->
                                                <!--:key="userListVms.id">-->
                                                <div class="team-player">
                                                    <img
                                                            :src="preUrl + userModel.rezomeDta[10].userListVms[(index-1)*3+1].subItemListImage"
                                                            alt="Thumbnail Image"
                                                            class="nav3-photo-container mb-3"
                                                    />
                                                    <div class="" style="bottom:0px !important;"
                                                         v-for="useDataVms in userModel.rezomeDta[10].userListVms[(index-1)*3+1].useDataVms"
                                                         :key="useDataVms.dataId">
                                                        <div class="" style="bottom:0px !important;"
                                                             v-for="userItemVms in userModel.rezomeDta[10].userItemVms"
                                                             :key="userItemVms.subitemId"
                                                        >
                                                            <div v-if="useDataVms.subItemId === userItemVms.subitemId"
                                                                 class="row justify-content-center">
                                                                <h4 class="title"
                                                                    v-if="userItemVms.subitemTitle === 'عنوان'">
                                                                    {{useDataVms.textData}}</h4>
                                                                <div v-else style="text-align: center;">
                                                                    <p class="category text-primary">
                                                                        {{userItemVms.subitemTitle}}</p>

                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 1 && useDataVms.textData !==''">
                                                                        {{
                                                                        useDataVms.textData}}</p>
                                                                    <p class="descriptionr"
                                                                       v-if="userItemVms.type === 2 && useDataVms.numberData!==0">
                                                                        {{
                                                                        useDataVms.numberData}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 3 && useDataVms.dateData!==''">
                                                                        {{convertDate(useDataVms.dateData)}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 4 && useDataVms.floatData!==0">
                                                                        {{
                                                                        useDataVms.floatData}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 5 && useDataVms.htmlData!==''"
                                                                       v-html="useDataVms.htmlData"></p>
                                                                    <img class="description"
                                                                         v-if="userItemVms.type === 6 && useDataVms.imageData!==''"
                                                                         :src="preUrl  + useDataVms.imageData"
                                                                         style="max-height: 15rem!important;"/>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4"
                                                 v-if="userModel.rezomeDta[10].userListVms[(index-1)*3+2]!== undefined"
                                            >
                                                <!--v-for="userListVms in userModel.rezomeDta[10].userListVms"-->
                                                <!--:key="userListVms.id">-->
                                                <div class="team-player">
                                                    <img
                                                            :src="preUrl + userModel.rezomeDta[10].userListVms[(index-1)*3+2].subItemListImage"
                                                            alt="Thumbnail Image"
                                                            class="nav3-photo-container mb-3"
                                                    />
                                                    <div class="" style="bottom:0px !important;"
                                                         v-for="useDataVms in userModel.rezomeDta[10].userListVms[(index-1)*3+2].useDataVms"
                                                         :key="useDataVms.dataId">
                                                        <div class="" style="bottom:0px !important;"
                                                             v-for="userItemVms in userModel.rezomeDta[10].userItemVms"
                                                             :key="userItemVms.subitemId"
                                                        >
                                                            <div v-if="useDataVms.subItemId === userItemVms.subitemId"
                                                                 class="row justify-content-center">
                                                                <h4 class="title"
                                                                    v-if="userItemVms.subitemTitle === 'عنوان'">
                                                                    {{useDataVms.textData}}</h4>
                                                                <div v-else style="text-align: center;">
                                                                    <p class="category text-primary">
                                                                        {{userItemVms.subitemTitle}}</p>

                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 1 && useDataVms.textData !==''">
                                                                        {{
                                                                        useDataVms.textData}}</p>
                                                                    <p class="descriptionr"
                                                                       v-if="userItemVms.type === 2 && useDataVms.numberData!==0">
                                                                        {{
                                                                        useDataVms.numberData}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 3 && useDataVms.dateData!==''">
                                                                        {{convertDate(useDataVms.dateData)}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 4 && useDataVms.floatData!==0">
                                                                        {{
                                                                        useDataVms.floatData}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 5 && useDataVms.htmlData!==''"
                                                                       v-html="useDataVms.htmlData"></p>
                                                                    <img class="description"
                                                                         v-if="userItemVms.type === 6 && useDataVms.imageData!==''"
                                                                         :src="preUrl  + useDataVms.imageData"
                                                                         style="max-height: 15rem!important;"/>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                    </div>
                </div>
                <hr/>
                <h2 v-if="banners!=null" class="text-center">{{banners.banner5}}</h2>

                <!-------------------------- زندگینامه33333333  ---------------------->
                <div class="col-md-10 ml-auto col-xl-10 mr-auto" v-if="userModel.rezomeDta[11] !==undefined">
                    <hr/>
                    <div class="section section-team text-center" style="top: 0;">
                        <div class="container">
                            <h3 class="text-center">{{userModel.rezomeDta[11].mainItemTitle}} </h3>
                            <el-carousel height="500px">
                                <el-carousel-item v-for="index in kindex" :key="index">
                                    <div class="team">
                                        <div class="row">
                                            <div class="col-md-4"
                                                 v-if="userModel.rezomeDta[11].userListVms[(index-1)*3]!== undefined"
                                            >
                                                <!--v-for="userListVms in userModel.rezomeDta[11].userListVms"-->
                                                <!--:key="userListVms.id">-->
                                                <div class="team-player">
                                                    <img
                                                            :src="preUrl + userModel.rezomeDta[11].userListVms[(index-1)*3].subItemListImage"
                                                            alt="Thumbnail Image"
                                                            class="nav3-photo-container mb-3"
                                                    />
                                                    <div class="" style="bottom:0px !important;"
                                                         v-for="useDataVms in userModel.rezomeDta[11].userListVms[(index-1)*3].useDataVms"
                                                         :key="useDataVms.dataId">
                                                        <div class="" style="bottom:0px !important;"
                                                             v-for="userItemVms in userModel.rezomeDta[11].userItemVms"
                                                             :key="userItemVms.subitemId"
                                                        >
                                                            <div v-if="useDataVms.subItemId === userItemVms.subitemId"
                                                                 class="row justify-content-center">
                                                                <h4 class="title"
                                                                    v-if="userItemVms.subitemTitle === 'عنوان'">
                                                                    {{useDataVms.textData}}</h4>
                                                                <div v-else style="text-align: center;">
                                                                    <p class="category text-primary">
                                                                        {{userItemVms.subitemTitle}}</p>

                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 1 && useDataVms.textData !==''">
                                                                        {{
                                                                        useDataVms.textData}}</p>
                                                                    <p class="descriptionr"
                                                                       v-if="userItemVms.type === 2 && useDataVms.numberData!==0">
                                                                        {{
                                                                        useDataVms.numberData}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 3 && useDataVms.dateData!==''">
                                                                        {{convertDate(useDataVms.dateData)}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 4 && useDataVms.floatData!==0">
                                                                        {{
                                                                        useDataVms.floatData}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 5 && useDataVms.htmlData!==''"
                                                                       v-html="useDataVms.htmlData"></p>
                                                                    <img class="description"
                                                                         v-if="userItemVms.type === 6 && useDataVms.imageData!==''"
                                                                         :src="preUrl  + useDataVms.imageData"
                                                                         style="max-height: 15rem!important;"/>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4"
                                                 v-if="userModel.rezomeDta[11].userListVms[(index-1)*3+1]!== undefined"
                                            >
                                                <!--v-for="userListVms in userModel.rezomeDta[11].userListVms"-->
                                                <!--:key="userListVms.id">-->
                                                <div class="team-player">
                                                    <img
                                                            :src="preUrl + userModel.rezomeDta[11].userListVms[(index-1)*3+1].subItemListImage"
                                                            alt="Thumbnail Image"
                                                            class="nav3-photo-container mb-3"
                                                    />
                                                    <div class="" style="bottom:0px !important;"
                                                         v-for="useDataVms in userModel.rezomeDta[11].userListVms[(index-1)*3+1].useDataVms"
                                                         :key="useDataVms.dataId">
                                                        <div class="" style="bottom:0px !important;"
                                                             v-for="userItemVms in userModel.rezomeDta[11].userItemVms"
                                                             :key="userItemVms.subitemId"
                                                        >
                                                            <div v-if="useDataVms.subItemId === userItemVms.subitemId"
                                                                 class="row justify-content-center">
                                                                <h4 class="title"
                                                                    v-if="userItemVms.subitemTitle === 'عنوان'">
                                                                    {{userListVms.useDataVms[0].textData}}</h4>
                                                                <div v-else style="text-align: center;">
                                                                    <p class="category text-primary">
                                                                        {{userItemVms.subitemTitle}}</p>

                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 1 && useDataVms.textData !==''">
                                                                        {{
                                                                        useDataVms.textData}}</p>
                                                                    <p class="descriptionr"
                                                                       v-if="userItemVms.type === 2 && useDataVms.numberData!==0">
                                                                        {{
                                                                        useDataVms.numberData}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 3 && useDataVms.dateData!==''">
                                                                        {{convertDate(useDataVms.dateData)}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 4 && useDataVms.floatData!==0">
                                                                        {{
                                                                        useDataVms.floatData}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 5 && useDataVms.htmlData!==''"
                                                                       v-html="useDataVms.htmlData"></p>
                                                                    <img class="description"
                                                                         v-if="userItemVms.type === 6 && useDataVms.imageData!==''"
                                                                         :src="preUrl  + useDataVms.imageData"
                                                                         style="max-height: 15rem!important;"/>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4"
                                                 v-if="userModel.rezomeDta[11].userListVms[(index-1)*3+2]!== undefined"
                                            >
                                                <!--v-for="userListVms in userModel.rezomeDta[11].userListVms"-->
                                                <!--:key="userListVms.id">-->
                                                <div class="team-player">
                                                    <img
                                                            :src="preUrl + userModel.rezomeDta[11].userListVms[(index-1)*3+2].subItemListImage"
                                                            alt="Thumbnail Image"
                                                            class="nav3-photo-container mb-3"
                                                    />
                                                    <div class="" style="bottom:0px !important;"
                                                         v-for="useDataVms in userModel.rezomeDta[11].userListVms[(index-1)*3+2].useDataVms"
                                                         :key="useDataVms.dataId">
                                                        <div class="" style="bottom:0px !important;"
                                                             v-for="userItemVms in userModel.rezomeDta[11].userItemVms"
                                                             :key="userItemVms.subitemId"
                                                        >
                                                            <div v-if="useDataVms.subItemId === userItemVms.subitemId"
                                                                 class="row justify-content-center">
                                                                <h4 class="title"
                                                                    v-if="userItemVms.subitemTitle === 'عنوان'">
                                                                    {{userListVms.useDataVms[0].textData}}</h4>
                                                                <div v-else style="text-align: center;">
                                                                    <p class="category text-primary">
                                                                        {{userItemVms.subitemTitle}}</p>

                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 1 && useDataVms.textData !==''">
                                                                        {{
                                                                        useDataVms.textData}}</p>
                                                                    <p class="descriptionr"
                                                                       v-if="userItemVms.type === 2 && useDataVms.numberData!==0">
                                                                        {{
                                                                        useDataVms.numberData}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 3 && useDataVms.dateData!==''">
                                                                        {{convertDate(useDataVms.dateData)}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 4 && useDataVms.floatData!==0">
                                                                        {{
                                                                        useDataVms.floatData}}</p>
                                                                    <p class="description"
                                                                       v-if="userItemVms.type === 5 && useDataVms.htmlData!==''"
                                                                       v-html="useDataVms.htmlData"></p>
                                                                    <img class="description"
                                                                         v-if="userItemVms.type === 6 && useDataVms.imageData!==''"
                                                                         :src="preUrl  + useDataVms.imageData"
                                                                         style="max-height: 15rem!important;"/>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                    </div>
                </div>

                <!-------------------------- زندگینامه 44444  ---------------------->
                <div class="col-md-10 ml-auto col-xl-10 mr-auto" v-if="userModel.rezomeDta[12] !==undefined">
                    <hr/>
                    <div class=" text-center" style="top: 0;">
                        <div class="container">
                            <h3 class="text-center">{{userModel.rezomeDta[12].mainItemTitle}} </h3>
                            <div class="team">
                                <div class="row">
                                    <div class="col-lg-4" v-for="userListVms in userModel.rezomeDta[12].userListVms"
                                         :key="userListVms.id">
                                        <div class="card team-player">
                                            <img
                                                    :src="preUrl + userListVms.subItemListImage"
                                                    alt="Thumbnail Image"
                                                    class="nav3-photo-container"
                                            />
                                            <div class="card-body" style="bottom:0px !important;"
                                                 v-for="useDataVms in userListVms.useDataVms"
                                                 :key="useDataVms.dataId">
                                                <div class="" style="bottom:0px !important;"
                                                     v-for="userItemVms in userModel.rezomeDta[12].userItemVms"
                                                     :key="userItemVms.subitemId">
                                                    <div v-if="useDataVms.subItemId == userItemVms.subitemId"
                                                         class="row justify-content-center">
                                                        <h4 class="title" v-if="userItemVms.subitemTitle=='عنوان'">
                                                            {{useDataVms.textData}}</h4>
                                                        <div v-else style="text-align: center;">
                                                            <p class="category text-primary">
                                                                {{userItemVms.subitemTitle}}</p>

                                                            <p class="description"
                                                               v-if="userItemVms.type === 1 && useDataVms.textData !==''">
                                                                {{
                                                                useDataVms.textData}}</p>
                                                            <p class="descriptionr"
                                                               v-if="userItemVms.type === 2 && useDataVms.numberData!==0">
                                                                {{
                                                                useDataVms.numberData}}</p>
                                                            <p class="description"
                                                               v-if="userItemVms.type === 3 && useDataVms.dateData!==''">
                                                                {{convertDate(useDataVms.dateData)}}</p>
                                                            <p class="description"
                                                               v-if="userItemVms.type === 4 && useDataVms.floatData!==0">
                                                                {{
                                                                useDataVms.floatData}}</p>
                                                            <p class="description"
                                                               v-if="userItemVms.type === 5 && useDataVms.htmlData!==''"
                                                               v-html="useDataVms.htmlData"></p>
                                                            <img class="description"
                                                                 v-if="userItemVms.type === 6 && useDataVms.imageData!==''"
                                                                 :src="preUrl  + useDataVms.imageData"
                                                                 style="max-height: 15rem!important;"/>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-------------------------- زندگینامه 55555  ---------------------->
                <div class="col-md-10 ml-auto col-xl-10 mr-auto" v-if="userModel.rezomeDta[13] !==undefined">
                    <hr/>
                    <h3 class="text-center">{{userModel.rezomeDta[13].mainItemTitle}} </h3>
                    <div class="row justify-content-center">
                        <div class="col-10">
                            <el-carousel style="height: 100% !important;">
                                <el-carousel-item v-for="userListVms in userModel.rezomeDta[13].userListVms"
                                                  :key="userListVms.id">
                                    <img class="d-block nav-photo-container"
                                         :src="preUrl + userListVms.subItemListImage"
                                         alt="First slide"/>
                                    <div class="" style="bottom:0px !important;">
                                        <h4 class="text_bold text-primary text-center p-3"
                                            style="text-shadow: 3px 3px 5px #FF0000">
                                            {{userListVms.useDataVms[0].textData}}</h4>
                                        <p class="text-black text-right p-2" style="text-shadow: 3px 3px 5px #a1a1a1;"
                                           v-html="userListVms.useDataVms[1].htmlData"></p>
                                    </div>
                                    <div>
                                        <a class="btn btn-info rounded"
                                           style="position: absolute;top: 250px; left: 20px;"
                                           @click="detailCliked(userListVms.subItemListId)"> بیشتر بخوانید</a>
                                    </div>
                                </el-carousel-item>

                            </el-carousel>
                        </div>
                    </div>
                </div>

            </div>

            <!-------------------- درخواست ------------------------>
            <div v-if="userOptions.showRequest" class="mt-5 px-5">
                <hr/>
                <h3 class="text-center mt-5" style="text-shadow: 3px 3px 5px #a1a1a1;">فرم درخواست از نامزد محترم
                    {{userModel.userData.fullName}}</h3>
                <div class="row border border-danger rounded"
                     style=" border-radius: 2rem !important; border:dashed !important;">
                    <div class="justify-content-center d-flex col-xl-4 col-lg-6" style="border-radius: 3rem;">
                        <div class="row w-100">
                            <div class="col-lg-4  p-2 mt-2 text-center align-self-center"
                            >
                                <span>نام و نام خانوادگی</span>
                            </div>
                            <!--<div class="col-lg-1"></div>-->
                            <input class="col-lg-8 p-2 mt-2 border-dark"
                                   style="border-width: 3px; background-color: antiquewhite; border-radius: 1rem !important;"
                                   type="text" v-model="requestModel.name">
                        </div>
                    </div>
                    <div class="justify-content-center d-flex col-xl-4 col-lg-6 mt-2" style="border-radius: 3rem;">
                        <div class="row w-100">
                            <div class="col-lg-4  p-2 mt-2 text-center align-self-center"
                            >
                                <span>شماره تماس</span>
                            </div>
                            <!--<div class="col-lg-1"></div>-->
                            <input class="col-lg-8 p-2 mt-2 border-dark bor"
                                   style="border-width: 3px; background-color: antiquewhite; border-radius: 1rem !important;"
                                   type="number" v-model="requestModel.mobile"
                                   placeholder="شماره همراه یا شماره ثابت با کد شهرستان و 11 رقم">
                        </div>
                    </div>
                    <div class="justify-content-center d-flex col-xl-4 col-lg-12 mt-2" style="border-radius: 3rem;">
                        <div class="row w-100">
                            <div class="col-lg-4 p-2 mt-2 text-center align-self-center"
                            >
                                <span>موضوع درخواست</span>
                            </div>
                            <!--<div class="col-lg-1 "></div>-->
                            <input class="col-lg-8 p-2 mt-2 border-dark bor"
                                   style="border-width: 3px; background-color: antiquewhite; border-radius: 1rem !important;"
                                   type="text" v-model="requestModel.subject">
                        </div>
                    </div>
                    <div class="justify-content-center d-flex col-12 mt-2" style="border-radius: 3rem;">
                        <div class="row w-100">
                            <div class="col-lg-4  p-2 mt-2 text-center align-self-center"
                            >
                                <span>شرح درخواست</span>
                            </div>
                            <div class="col-lg-1 "></div>
                            <textarea class="col-lg-6 p-2 mt-2 border-dark bor"
                                      style="border-width: 3px; background-color: antiquewhite; border-radius: 1rem !important;"
                                      type="text" v-model="requestModel.description"></textarea>
                        </div>
                    </div>
                    <div class="d-flex col-12 mt-3 justify-content-center" style="border-radius: 3rem;">
                        <a class="btn btn-success " @click="submitRequest()"><h4 class="m-2">ثبت درخواست</h4></a>
                    </div>

                </div>
            </div>
            <!--------------------------- نظرات کاربران------------------->
            <div v-if="userOptions.showComment" class="mt-5">
                <hr/>
                <div class="text-center">
                    <h3>نظر خود را با ما در میان بگذارید</h3>
                    <div class="text-center my-lg-1 my-2">
                        <a class="oncommentclick btn btn-cyan bg border-0 mx-3 pl-2 pr-2 pt-2 pb-2 border-radius-1 font-weight-bold"
                           @click="onReComment(0)">ثبت نظر</a>
                        تعداد پسندها
                        <a @click="onCommentLike(0)"
                           class="btn-color-like text-c-white clickable pt-2">
                            <i class="fa fa-thumbs-up"><span
                                    class="farsi-digits font-size-1">{{userLikes.likeCount}}</span></i>
                        </a>
                    </div>
                </div>

                <hr/>
                <h3 class="text-center mt-5" style="text-shadow: 3px 3px 5px #a1a1a1;">نظرات کاربران</h3>
                <div class="m-3">
                    <div class="mt-3 mx-5 px-5" v-for="item in comments" :key="item.id">
                        <div class="mt-2 p-2 border border-red " style="border-radius: 3rem !important;">
                            <div class="row">
                                <div class="col-lg-4 col-6 pb-lg-2 pt-2 pr-5 text-right">
                                    <i class="fa fa-user"></i>
                                    {{item.name}}
                                </div>
                                <div class="col-lg-6 col-6 pb-lg-2 pt-2 text-left font-weight-800 font-size-small">
                                    {{item.createOn}}
                                </div>
                                <div class="col-lg-1 p-0 col-6 text-center my-lg-1 my-2">

                                    <a @click="onCommentLike(item.id)"
                                       class="btn-color-like text-c-white clickable pt-2">
                                        <i class="fa fa-thumbs-up">
                                                            <span class="farsi-digits font-size-1">
                                                                {{item.liked}}
                                                            </span>
                                        </i>
                                    </a>
                                </div>
                                <div class="col-lg-1 p-0 col-6 text-center my-lg-1 my-2">

                                    <a @click="onCommentDisLike(item.id)"
                                       class="btn-color-dislike text-c-white clickable">
                                        <i class="fa fa-thumbs-down">
                                                            <span class="farsi-digits font-size-small">
                                                                {{item.disLiked}}
                                                            </span>
                                        </i>
                                    </a>
                                </div>
                            </div>
                            <div class="col border-top border-top-red p-3">
                                <p class="text-justify font-size-1">{{item.description}}</p>
                            </div>
                            <div class="col-12 text-left">
                                <a class="oncommentclick btn btn-cyan bg border-0 mr-auto ml-auto pl-2 pr-2 pt-2 pb-2 border-radius-1 font-size-small"
                                   @click="onReComment(item.id)">پاسخ به این نظر</a>
                            </div>
                        </div>
                        <div v-if="item.comments != null">
                            <!--<div class="mt-3 mx-5 px-5" v-for="item2 in item.comments" :key="item2.id">-->
                            <!--<div class="mt-2 p-2 border border-red " style="border-radius: 3rem !important;">-->
                            <!--<div class="row">-->
                            <!--<div class="col-lg-4 col-6 pb-lg-2 pt-2 pr-5 text-right">-->
                            <!--<i class="fa fa-user"></i>-->
                            <!--{{item2.name}}-->
                            <!--</div>-->
                            <!--<div class="col-lg-6 col-6 pb-lg-2 pt-2 text-left font-weight-800 font-size-small">-->
                            <!--{{item2.createOn}}-->
                            <!--</div>-->
                            <!--<div class="col-lg-1 p-0 col-6 text-center my-lg-1 my-2">-->

                            <!--<a @click="onCommentLike(item2.id)"-->
                            <!--class="btn-color-like text-c-white clickable pt-2">-->
                            <!--<i class="fa fa-thumbs-up">-->
                            <!--<span class="farsi-digits font-size-1">-->
                            <!--{{item2.liked}}-->
                            <!--</span>-->
                            <!--</i>-->
                            <!--</a>-->
                            <!--</div>-->
                            <!--<div class="col-lg-1 p-0 col-6 text-center my-lg-1 my-2">-->

                            <!--<a @click="onCommentDisLike(item2.id)"-->
                            <!--class="btn-color-dislike text-c-white clickable">-->
                            <!--<i class="fa fa-thumbs-down">-->
                            <!--<span class="farsi-digits font-size-small">-->
                            <!--{{item2.disLiked}}-->
                            <!--</span>-->
                            <!--</i>-->
                            <!--</a>-->
                            <!--</div>-->
                            <!--</div>-->
                            <!--<div class="col border-top border-top-red p-3">-->
                            <!--<p class="text-justify font-size-1">{{item2.description}}</p>-->
                            <!--</div>-->
                            <!--<div class="col-12 text-left">-->
                            <!--<a class="oncommentclick btn btn-cyan bg border-0 mr-auto ml-auto pl-2 pr-2 pt-2 pb-2 border-radius-1 font-size-small"-->
                            <!--@click="onReComment(item2.id)">پاسخ به این نظر</a>-->
                            <!--</div>-->
                            <!--</div>-->

                            <!--</div>-->
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <modal :show.sync="modalShow" headerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">ثبت نظرات کاربران</h4>

            <div class="row">
                <div class="d-flex col-12" style="border-radius: 3rem;">
                    <div class="row w-100">
                        <div class="col-lg-4  p-2 mt-2 text-center align-self-center"
                        >
                            <span>نام و نام خانوادگی</span>
                        </div>
                        <input class="col-lg-6 p-2 mt-2 border-dark"
                               style="border-width: 3px; background-color: antiquewhite; border-radius: 1rem !important;"
                               type="text" v-model="commentModel.name">
                    </div>
                </div>
                <div class="d-flex col-12 mt-2" style="border-radius: 3rem;">
                    <div class="row w-100">
                        <div class="col-lg-4 p-2 mt-2 text-center align-self-center"
                        >
                            <span>تحصیلات</span>
                        </div>
                        <div class="col-lg-6 p-2 mt-2 border-dark bor"
                             style="border-width: 3px; background-color: antiquewhite; border-radius: 1rem !important;"
                        >
                            <vs-select :data="enEducation" :mode="'create'"
                                       :header="{multiple: false, label: 'title'}"
                                       @onChange="onSelectEducation"></vs-select>
                        </div>
                    </div>
                </div>
                <div class="d-flex col-12 mt-2" style="border-radius: 3rem;">
                    <div class="row w-100">
                        <div class="col-lg-4  p-2 mt-2 text-center align-self-center"
                        >
                            <span>شرح نظر</span>
                        </div>
                        <textarea class="col-lg-6 p-2 mt-2 border-dark bor"
                                  style="border-width: 3px; background-color: antiquewhite; border-radius: 1rem !important;"
                                  type="text" v-model="commentModel.description"></textarea>
                    </div>
                </div>
            </div>


            <template slot="footer">
                <n-button @click="submitComment">ثبت</n-button>
                <n-button type="danger" @click.native="modalShow = false"
                >انصراف
                </n-button
                >
            </template>
        </modal>

        <!--&lt;!&ndash; small modal &ndash;&gt;-->
        <!--<modal-->
        <!--:show.sync="modals.mini"-->
        <!--class="modal-primary"-->
        <!--:show-close="false"-->
        <!--headerClasses="justify-content-center"-->
        <!--type="mini"-->
        <!--&gt;-->
        <!--<div slot="header" class="modal-profile">-->
        <!--<i class="now-ui-icons users_circle-08"></i>-->
        <!--</div>-->
        <!--<p>Always have an access to your profile</p>-->
        <!--<template slot="footer">-->
        <!--<n-button type="neutral" link>Back</n-button>-->
        <!--<n-button type="neutral" link @click.native="modals.mini = false"-->
        <!--&gt;Close</n-button-->
        <!--&gt;-->
        <!--</template>-->
        <!--</modal>-->

    </div>

</template>
<script>
    import BaseService from "../_framework/api/BaseService";
    import Moment from 'moment-jalali';
    import Utils from "../_framework/utils/Utils";
    import Constants from "../_framework/Constants";
    import {Card, Tabs, TabPane, Progress, Modal, Button} from '@/components';
    import {Carousel, CarouselItem} from 'element-ui';
    import Vue from 'vue'
    import VueNoty from 'vuejs-noty'
    import 'vuejs-noty/dist/vuejs-noty.css'
    import VsSelect from '../_framework/VsSelect.vue';
    import * as $ from 'jquery';
    import 'vue-select/dist/vue-select.css';

    Vue.use(VueNoty);


    export default {
        name: 'profile',
        bodyClass: 'profile-page',
        components: {
            [Button.name]: Button,
            Modal,
            Tabs,
            Card,
            TabPane,
            [Carousel.name]: Carousel,
            [CarouselItem.name]: CarouselItem,
            [Progress.name]: Progress,
            VsSelect
        },
        data() {
            return {
                preUrl: Constants.BASE_URL,
                netMode: "",
                isLoading: false,
                userModel: {
                    userData: {
                        city: "",
                        fullName: "",
                        mainJob: "",
                        provience: "",
                        userImage: ""
                    },
                    netData: [{
                        icon: "",
                        name: "",
                        number: "",
                        urlLink: ""
                    }],
                    rezomeDta: [{
                        userItemVms: [],
                        userListVms: [{
                            useDataVms: [],
                        }],
                    }],

                },
                kindex: 0,
                kdata: [],
                userId: 0,
                userOptions: {
                    showComment: false,
                    showLike: false,
                    showRequest: false,
                },
                userLikes: {
                    disLikeCount: 0,
                    likeCount: 0,
                    viewCount: 0,
                    comments: 0,
                    requests: 0
                },
                requestModel: {
                    name: "",
                    mobile: "",
                    subject: "",
                    description: "",
                    userId: 0,
                },
                comments: [{
                    id: 0,
                    createOn: "",
                    age: 0,
                    description: "",
                    disLiked: 0,
                    liked: 0,
                    name: "",
                    education: "",

                }],
                enEducation: {},
                commentModel: {
                    name: "",
                    mobile: "",
                    age: 0,
                    education: "",
                    description: "",
                    commentsId: 0,
                    userId: 0,
                },
                modalShow: false,
                commentId: 0,
                slectedEducation: "",
                banners: {

                    banner1: "",
                    banner2: "",
                    banner3: "",
                    banner4: "",
                    banner5: "",

                },


            }
        },
        mounted() {

            this.userId = Constants.USER_ID;
            this.getUserData();
            this.getUserLikes();
            this.getUserOptions();
            this.getComments();
            this.getBanners();
            this.getEnEducation();
            this.updateView();
        },
        methods: {
            getUserData() {
                this.isLoading = true;
                let p = {
                    userId: this.userId
                };
                new BaseService("RezomeReport", "/GetUserDatas").getList(p).then(response => {
                    this.isLoading = false;
                    this.userModel = response.data;
                    // this.userModel.userData.userNewImage = this.validateImageUrl(this.userModel.userData.userImage)
                    this.userModel.userData.userNewImage = Constants.BASE_URL + this.userModel.userData.userImage;
                    this.dex();
                    // if (this.userModel.birthDay !== null) {
                    //     this.birthDay = Moment(this.gregorianToJalali(this.userModel.birthDay), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                    // }
                }).catch(error => {
                    // console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getUserLikes() {
                let p = {
                    userId: this.userId
                };
                new BaseService("User", "/GetViewLike").getList(p).then(response => {
                    this.userLikes = response.data;
                }).catch(error => {
                    // console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getUserOptions() {
                let p = {
                    userId: this.userId
                };
                new BaseService("User", "/GetUserOptions").getList(p).then(response => {
                    this.userOptions = response.data;
                }).catch(error => {
                    // console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getComments() {
                let p = {
                    userId: this.userId
                };
                new BaseService("User", "/GetComments").getList(p).then(response => {
                    this.comments = response.data;
                    if (this.comments.length > 0) {
                        for (let i of this.comments) {
                            i.createOn = Moment(this.gregorianToJalali(i.createOn), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                        }
                    }
                }).catch(error => {
                });
            },
            getBanners() {
                let p = {
                    userId: this.userId
                };
                new BaseService("User", "/GetBanners").getList(p).then(response => {
                    this.banners = response.data;

                }).catch(error => {
                });
            },
            getEnEducation() {
                new BaseService("User", "/GetEnEducation").getList().then(response => {
                    this.enEducation = response.data;
                }).catch(error => {
                    // console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            updateView() {
                let p = {
                    userId: this.userId
                };
                new BaseService("User", "/IncreaseView").update(p).then(response => {
                    // this.userOptions = response.data;
                }).catch(error => {
                    // console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            detailCliked(id) {
                this.$router.push({
                    name: 'profileDetail',
                    params: {
                        listId: id
                    }
                });
            },
            dex() {
                this.kindex = Math.floor(this.userModel.rezomeDta[4].userListVms.length / 2.8) + 1;
            },
            convertDate(gdate) {
                // console.log(gdate)
                return Moment(gdate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY') ;//format('jYYYY/jMM/jDD');
                // return Moment(this.gregorianToJalali(gdate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY')
            },
            submitRequest() {
                if (this.requestModel.name === '') {
                    this.$noty.warning('نام وارد نشده است!');
                } else if (this.requestModel.mobile === '') {
                    this.$noty.warning('شماره تماس وارد نشده است!');
                } else if (this.requestModel.subject === '') {
                    this.$noty.warning('موضوع به درستی وارد نشده است!');
                } else if (this.requestModel.description === '') {
                    this.$noty.warning('شرح درخواست وارد نشده است!');
                } else {
                    this.requestModel.userId = this.userId;

                    new BaseService("RezomeReport", "/InsertRequest").create(this.requestModel).then(response => {
                        this.$noty.success('با تشکر، درخواست شما با موفقیت ثبت شد، در صورت نیاز با شما تماس گرفته میشود.');
                        this.requestModel.name = '';
                        this.requestModel.mobile = '';
                        this.requestModel.subject = '';
                        this.requestModel.description = '';
                    }).catch(error => {
                        // console.log(error);
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                }
            },
            submitComment() {
                if (this.commentModel.name === '') {
                    this.$noty.warning('نام وارد نشده است!');
                } else if (this.slectedEducation === '') {
                    this.$noty.warning('میزان تحصیلات خود را مشخص کنید!');
                } else if (this.commentModel.description === '') {
                    this.$noty.warning('شرح درخواست وارد نشده است!');
                } else {
                    this.commentModel.commentsId = this.commentId;
                    this.commentModel.userId = this.userId;
                    this.commentModel.education = this.slectedEducation;

                    new BaseService("RezomeReport", "/InsertComment").create(this.commentModel).then(response => {
                        this.$noty.success('با تشکر، نظر شما با موفقیت ثبت شد،');
                        this.commentModel.name = '';
                        this.commentModel.mobile = '';
                        this.commentModel.subject = '';
                        this.commentModel.description = '';
                        this.slectedEducation = '';
                        this.commentId = 0;
                        this.modalShow = false;

                    }).catch(error => {
                        // console.log(error);
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                }
            },
            onSelectEducation(val) {
                this.slectedEducation = val.title;
            },
            onCommentLike(id) {
                if (id == 0) {
                    let mode = {
                        showLike: true,
                        userId: this.userId,
                    };
                    new BaseService("User", "/IncreaseLike").update(mode).then(response => {
                        this.$noty.success('با تشکر، نظر شما با موفقیت ثبت شد،');
                        this.getUserLikes();
                    }).catch(error => {
                        // console.log(error);
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                } else {
                    let mode = {
                        id: id,
                        showLike: true,
                        userId: this.userId,
                    };
                    new BaseService("User", "/IncreaseCommentLike").update(mode).then(response => {
                        this.$noty.success('با تشکر، نظر شما با موفقیت ثبت شد،');
                        this.getComments();
                    }).catch(error => {
                        // console.log(error);
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                }
            },
            onCommentDisLike(id) {
                let mode = {
                    id: id,
                    showLike: false,
                    userId: this.userId,
                };
                new BaseService("User", "/IncreaseCommentLike").update(mode).then(response => {
                    this.$noty.success('با تشکر، نظر شما با موفقیت ثبت شد،');
                    this.getComments();
                }).catch(error => {
                    // console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            onReComment(id) {
                this.modalShow = true;
                this.commentId = id;
                // console.log(this.modalShow)
                // $("#commentModal").modal("show");
            },


        },
        // beforeRouteLeave(to, from, next) {
        //
        //         next();
        //
        // },


    }
    ;
</script>
<style>

</style>
